import { useMemo } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next/useAnalyticsEvents';
import { fireAnalyticsEvent } from '@atlaskit/editor-common/analytics/fire-analytics-event';
import type { FireAnalyticsCallback } from '@atlaskit/editor-common/analytics/types/events';

export function useFireAnalyticsEvent(): FireAnalyticsCallback {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	return useMemo(() => fireAnalyticsEvent(createAnalyticsEvent), [createAnalyticsEvent]);
}
